var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"social-title font-weight-bold pl-3 pr-3 pt-1 pb-1 pl-md-6 pr-md-6 pt-md-2 pb-md-2 white--text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }